import {Palette} from '../type/palette.type';

export const auctionsPalette: Palette = {
  50:  '#e8f7fd',
  100: '#d1f0fb',
  200: '#a3e1f8',
  300: '#75d2f5',
  400: '#47c4f2',
  500: '#26ace4',
  600: '#1e8aba',
  700: '#166890',
  800: '#0e4666',
  900: '#06243c'
}

export const auctionsSurfacePalette: Palette = {
  50:  '#fcfbfa',
  100: '#fcfbfa',
  200: '#f7f5f2',
  300: '#f4f1ec',
  400: '#e8e4de',
  500: '#f3f0eb',
  600: '#bab5af',
  700: '#918c86',
  800: '#67625c',
  900: '#3d3933',
  950: '#3d3933'
}
